import { createContext } from 'react';

export type LayoutCompanyContextValue = {
  toggle: boolean;
  onToggle: (value?: boolean) => void;
};

export const LayoutCompanyContext = createContext<LayoutCompanyContextValue>({
  toggle: false,
  onToggle: () => {},
});
